var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-test-id":"fixed-points-inputs"}},[_c('validated-input',{attrs:{"label":"Points","name":"points","rules":{
      required: true
    }}},[_c('numberinput-fractional',{attrs:{"min":0.01,"default-value":1},model:{value:(_vm.value.awardPolicy.points),callback:function ($$v) {_vm.$set(_vm.value.awardPolicy, "points", $$v)},expression:"value.awardPolicy.points"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }